import { PageType } from "../../../config/page.types";
import PlaceholderView from "../../PlaceholderView";

const KnowHowKnowledgeBase = () => {
	return <PlaceholderView pageType={PageType.KnowHowKnowledgeBase} text="Knowledge base" />;
};

export default KnowHowKnowledgeBase;
